<div *transloco="let t" class="h-dvh w-screen custom-scrollbar bg-gray-50">
    <div class="h-[70px] w-screen animated-bg flex items-center px-5">
        <div (click)="goBack(t)" class="h-[70px] flex gap-3 items-center cursor-pointer w-full">
            <div class="text-white text-[60px] leading-[60px] h-fit"><svg class="h-[50px] w-[24px]" fill="white"
                    width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.00214 11.0033V8.0026C9.64044 8.0026 10.9842 9.05783 12.5036 11.0033C12.5036 7.2765 11.2667 3.50162 6.00214 3.50162V0.500961L0.500946 5.75211L6.00214 11.0033Z"
                        stroke="white" stroke-width="1.00189" stroke-linejoin="round" />
                </svg>
            </div>
            <div class="text-white text-[20px] font-semibold">{{t('goBack')}}</div>

        </div>
        <div (click)="prevSessions(t)"
            class="ml-auto cursor-pointer text-white text-[24px] px-3 border-[4px] border-white rounded-lg h-fit font-bold w-fit whitespace-nowrap mr-5">
            {{t('prevSessions')}}</div>
        <div (click)="startLive(t)"
            class="ml-auto cursor-pointer text-white text-[24px] px-3 border-[4px] border-white rounded-lg h-fit font-bold">
            {{t('startLive')}}</div>
    </div>
    <div class="p-10 max-h-[calc(100svh-70px)] custom-scrollbar overflow-y-scroll overflow-x-hidden">
        <div class="text-black text-[32px] font-semibold text-center">{{t('createYourQuizWithMap')}}</div>
        <div class="max-w-full custom-scrollbar overflow-x-scroll overflow-y-hidden">
            <div class="flex rounded-xl w-fit items-center bg-gray-950 h-[100px] mt-20 px-5">
                <div
                    class="text-white rounded-xl cursor-not-allowed border-white border-[2px] h-[60px] font-semibold text-[22px] flex items-center p-3 place-content-center w-[150px]">
                    {{t('startQuiz')}}</div>
                <div class="plus-add-block" (click)="indexForAddQuestion = 0;spawnModalBlock($event)">
                    <div
                        class="h-[60px] w-full rounded-xl cursor-pointer text-[32px] border-white border-[2px] bg-blue-500 flex items-center place-content-center text-white font-semibold">
                        +</div>
                </div>
                <div></div>
                @for (slide of myQuiz.questions; track $index) {
                <div [title]="slide.title" [ngClass]="{'!border-red-600 !text-red-600': currentSlideToShow === $index}"
                    (click)="saveSlide(currentSlideToShow);currentSlideToShow = $index"
                    class="text-white rounded-xl cursor-pointer border-white border-[2px] h-[60px] font-semibold text-[22px] flex items-center p-3 place-content-center w-[150px]">
                    Q{{$index + 1}}</div>
                <div></div>
                <div class="plus-add-block"
                    (click)="indexForAddQuestion = $index + 1;saveSlide(currentSlideToShow);spawnModalBlock($event)">
                    <div
                        class="h-[60px] w-full rounded-xl cursor-pointer text-[32px] border-white border-[2px] bg-blue-500 flex items-center place-content-center text-white font-semibold">
                        +</div>
                </div>
                <div></div>
                }
                <div
                    class="text-white rounded-xl cursor-not-allowed border-white border-[2px] h-[60px] font-semibold text-[22px] flex items-center p-3 place-content-center w-[150px]">
                    {{t('endQuiz')}}</div>
            </div>
        </div>
        <div class="mt-5 max-w-[500px]">
            <std-input class="relative" (keyup)="updateQuiz()" customInputClass="custom-input"
                [(ngModel)]="myQuiz.title" labelPosition="top" customLabel="mt-2 label-input" [label]="t('title')"
                [placeholder]="t('title')">
                <div iconLeft class="absolute right-0 top-0">
                    <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="top"
                            classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                            [show]="tipToShow == 1">
                            <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                {{t('tips.quizTitle')}}
                            </div>
                            <img content (click)="showTip(1)" class="size-8 cursor-pointer" src="./assets/question.svg">
                        </std-tooltip></std-click-outside>
                </div>
            </std-input>
            <std-input class="relative" (keyup)="updateQuiz()" customInputClass="custom-input !rounded-xl"
                type="textarea" [(ngModel)]="myQuiz.description" labelPosition="top" customLabel="mt-2 label-input"
                [label]="t('description')" [placeholder]="t('description')">
                <div iconLeft class="absolute right-0 top-2">
                    <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="top"
                            classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                            [show]="tipToShow == 2">
                            <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                {{t('tips.quizDesc')}}
                            </div>
                            <img content (click)="showTip(2)" class="size-8 cursor-pointer" src="./assets/question.svg">
                        </std-tooltip></std-click-outside>
                </div>
            </std-input>
            <a [href]="t('routes.rules.path')" target="_blank"><div class="font-bold mt-5 cursor-pointer text-[24px] hover:underline">{{t('completeRules')}}</div></a>

        </div>
        <div class="w-full h-0.5 bg-black my-5"></div>
        @if(currentSlideToShow > -1){<div>
            <div class="mt-10 flex gap-5">
                <div class="w-[calc(50%-10px)]"><std-button (click)="deleteSlide()">{{t('modal.delete')}}</std-button>
                </div>
                <!-- <div class="w-[calc(50%-10px)]"><std-button (click)="saveQuiz()">{{t('saveEdit')}}</std-button></div> -->
            </div>
            <div>
                <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]"
                    [(ngModel)]="myQuiz.questions[currentSlideToShow].title" labelPosition="top"
                    customLabel="mt-2 label-input" [label]="t('question')" [placeholder]="t('question')">
                    <div iconLeft class="absolute right-0 top-0">
                        <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                [show]="tipToShow == 3">
                                <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                    {{t('tips.quizQuestion')}}
                                </div>
                                <img content (click)="showTip(3)" class="size-8 cursor-pointer"
                                    src="./assets/question.svg">
                            </std-tooltip></std-click-outside>
                    </div>
                </std-input>
            </div>
            <div class="">
                @if(myQuiz.questions[currentSlideToShow].type == 1 ||
                myQuiz.questions[currentSlideToShow].type == 2){
                
                @for (item of [].constructor(5); track $index) {
                @if($index == 0 || myQuiz.questions[currentSlideToShow].question_options[$index - 1]?.option_text){
                <div class="flex gap-5 w-full items-end">
                    <std-input class="relative w-full" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].question_options[$index].option_text"
                        (ngModelChange)="myQuiz.questions[currentSlideToShow].question_options[$index].is_correct ? changeCurrentCorrectValue(myQuiz.questions[currentSlideToShow].question_options[$index].option_text) : null"
                        labelPosition="top" customLabel="mt-2 label-input" [label]="t('answerNumber',{number:$index + 1})"
                        [placeholder]="t('answerNumber',{number:$index + 1})">
                        <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 4 + $index">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizAnswer')}}
                                    </div>
                                    <img content (click)="showTip(4 + $index)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div>
                    </std-input>
                    <std-checkbox borderRadius="99px"
                        (click)="changeCorrectAnswer($index)"
                        (onChange)="changeCorrectAnswer($index);updateSlides($event)"
                        [ngClass]="{'pointer-events-none': myQuiz.questions[currentSlideToShow].question_options[$index].is_correct}"
                        [isChecked]="myQuiz.questions[currentSlideToShow].question_options[$index].is_correct"></std-checkbox>
                </div>
                }
                }
                
                
                }
                @if(myQuiz.questions[currentSlideToShow].type == 3){
                <div>
                    <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input pointer-events-none"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].correct_value" labelPosition="top"
                        customLabel="mt-2 label-input" [label]="t('mapPosition')"
                        [placeholder]="t('mapPosition')">
                    <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 9">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizCorrectAnswer')}}
                                    </div>
                                    <img content (click)="showTip(9)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div></std-input>
                    <div class="py-10"> <google-map height="500px" width="500px" [zoom]="2"
                            (mapClick)="onMapClick($event)">
                            <map-marker *ngIf="myQuiz.questions[currentSlideToShow].correct_value"
                                [position]="{lat:toFloat(myQuiz.questions[currentSlideToShow].correct_value.split(',')[0]),lng:toFloat(myQuiz.questions[currentSlideToShow].correct_value.split(',')[1])}">
                            </map-marker>
                        </google-map></div>

                    <!-- <p *ngIf="myQuiz.questions[currentSlideToShow].correct_value">
                        Lat: {{ myQuiz.questions[currentSlideToShow].correct_value.split(',')[0] }}, Lng: {{ myQuiz.questions[currentSlideToShow].correct_value.split(',')[1] }}
                    </p> -->
                </div>
                }
                @if(myQuiz.questions[currentSlideToShow].type == 4){
                <div>
                    <std-input class="relative w-full" (keyup)="updateSlides($event)" customInputClass="custom-input"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].correct_value" labelPosition="top"
                        customLabel="mt-2 label-input" [label]="t('correct_value')"
                        [placeholder]="t('correct_value')">
                        <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 9">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizCorrectAnswer')}}
                                    </div>
                                    <img content (click)="showTip(9)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div>
                    </std-input>
                </div>
                }
            </div>
            <div class="">
                <div>
                    <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]" type="text"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].question_settings.base_points"
                        labelPosition="top" customLabel="mt-2 label-input" [label]="t('base_points')"
                        [placeholder]="t('base_points')">
                    <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 10">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizBasePoints')}}
                                    </div>
                                    <img content (click)="showTip(10)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div>
                    </std-input>
                </div>
                @if(myQuiz.questions[currentSlideToShow].type != 2){<div>
                    <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]" type="text"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].question_settings.bonus_best"
                        labelPosition="top" customLabel="mt-2 label-input" [label]="t('bonus_best')"
                        [placeholder]="t('bonus_best')">
                    <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 11">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizBestAnswer')}}
                                    </div>
                                    <img content (click)="showTip(11)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div>
                    </std-input>
                </div>}
                <div>
                    <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]" type="text"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].question_settings.wrong_answer_points"
                        labelPosition="top" customLabel="mt-2 label-input" [label]="t('wrong_answer_points')"
                        [placeholder]="t('wrong_answer_points')">
                    <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 12">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizWrongAnswer')}}
                                    </div>
                                    <img content (click)="showTip(12)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div></std-input>
                </div>
                @if(myQuiz.questions[currentSlideToShow].type == 2){<div>
                    <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]" type="text"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].question_settings.buzzer_duration_seconds"
                        labelPosition="top" customLabel="mt-2 label-input" [label]="t('buzzer_duration_seconds')"
                        [placeholder]="t('buzzer_duration_seconds')">
                    <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 13">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizQuestionDuration')}}
                                    </div>
                                    <img content (click)="showTip(13)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div></std-input>
                </div>}

                <div>
                    <std-input class="relative" (keyup)="updateSlides($event)" customInputClass="custom-input w-[250px]" type="text"
                        [(ngModel)]="myQuiz.questions[currentSlideToShow].question_settings.duration_seconds"
                        labelPosition="top" customLabel="mt-2 label-input" [label]="t('duration_seconds')"
                        [placeholder]="t('duration_seconds')">
                    <div iconLeft class="absolute right-0 top-0">
                            <std-click-outside (clickOutside)="tipToShow = -1"> <std-tooltip position="left-top"
                                    classTooltip="!w-fit max-w-[250px]! bg-white shadow-xl h-auto border-[1px] border-black"
                                    [show]="tipToShow == 14">
                                    <div class="flex gap-5 px-2 items-center w-[250px]" tooltip>
                                        {{t('tips.quizQuestionBuzzerDuration')}}
                                    </div>
                                    <img content (click)="showTip(14)" class="size-8 cursor-pointer" src="./assets/question.svg">
                                </std-tooltip></std-click-outside>
                        </div></std-input>
                </div>

                <div>
                    <std-select customInputClass="custom-input w-[250px]"
                        (onChangeValue)="changeSelectSettings($event,'show_rank')"
                        [currentValue]="myQuiz.questions[this.currentSlideToShow].question_settings.show_rank ? {value:true,label:t('yes')}:{value:false,label:t('no')}"
                        [data]="[{value:false,label:t('no')},{value:true,label:t('yes')}]" labelPosition="top"
                        customLabel="mt-2 label-input" [label]="t('show_rank')"
                        [placeholder]="t('show_rank')"></std-select>
                </div>


            </div>
        </div>}

    </div>

    <div id="modal-create-block" (click)="hideModal()"
        class="hidden items-center h-[100vh] w-[50px] place-content-center fixed z-50 transition-all">
        <div (click)="$event.stopPropagation()" id="modal-create-block-content"
            class="size-0 bg-white p-[25px] border-black border-[2px] overflow-hidden rounded-full transition-all">
            <div class="" id="modal-block-inside">
                <svg class="size-[32px] ml-auto" (click)="hideModal()" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640">
                    <path
                        d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z" />
                </svg>
                <div class="flex gap-5 items-end">
                    <div style="transition-duration: 100ms;" class="w-full"
                        [ngClass]="{'w-[calc(100%-58px)]': newTypeQuestion > -1}"><std-select
                            (onChangeValue)="changeTypeQuestion($event)" direction="down" labelPosition="top"
                            [label]="t('typeQuestion')" [placeholder]="t('typeQuestion')" [data]="[
                {value:1,label:t('typeQuestion0')},
                {value:2,label:t('typeQuestion1')},
                {value:3,label:t('typeQuestion2')},
                {value:4,label:t('typeQuestion3')},
            ]"></std-select></div>
                    @if(newTypeQuestion > -1){
                    <svg (click)="showExample = !showExample" class="size-[38px]" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640">
                        <path
                            d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224zM280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z" />
                    </svg>
                    }

                </div>
                @if(showExample === true){
                <!-- <div class="py-5 w-full h-[400px] bg-black">

                </div> -->
                }
                @if(newTypeQuestion > -1){
                <std-button (click)="addIntermission(t)" buttonClass="mt-5">{{t('addQuestion')}}</std-button>
                }
            </div>
        </div>
    </div>
    <std-modal [show]="errors.length > 0" (close)="errors = []">
        <div header class="text-white font-bold">{{t('errorsQuiz.title')}}</div>
        <div content class="max-h-[40vh] overflow-y-scroll custom-scrollbar">
            <div class="font-medium text-[18px] mb-2">{{t('descErrorsQuiz')}}</div>
            @for (error of errors; track $index) {
                <div>{{($index+1)+')'}} {{error}}</div>
            }
        </div>
    </std-modal>
</div>